import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css";

function Contact() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("contattiPage.titolo")} | Andromeda Programmazione</title>
        <meta 
          name="description" 
          content={t("contattiPage.descrizione", "Contatta Andromeda Programmazione per informazioni e supporto su sviluppo web, e-commerce e software personalizzati. San Cesario di Lecce (LE).")} 
        />
        <meta 
          name="keywords" 
          content="contatti andromeda programmazione, sviluppo web Lecce, contatti programmatore, email info andromedaprog, telefono sviluppo software, contatti IT Lecce" 
        />
        <link rel="canonical" href="https://www.andromedaprog.it/contatti" />

        <meta property="og:title" content={`${t("contattiPage.titolo")} | Andromeda Programmazione`} />
        <meta 
          property="og:description" 
          content={t("contattiPage.descrizione", "Contatta Andromeda Programmazione per informazioni su sviluppo web e software personalizzati.")} 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.andromedaprog.it/contatti" />
        <meta property="og:image" content="https://www.andromedaprog.it/images/hero-bg.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${t("contattiPage.titolo")} | Andromeda Programmazione`} />
        <meta 
          name="twitter:description" 
          content={t("contattiPage.descrizione", "Contatta Andromeda Programmazione per sviluppo web e software personalizzati.")} 
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <section id="contatti" className="contact-section py-5">
        <div className="container">
          {/* 🔥 TITOLO SENZA DESCRIZIONE */}
          <div className="text-center mb-5" data-aos="fade-down">
            <h2 className="contact-title">{t("contattiPage.titolo")}</h2>
          </div>

          <div className="row align-items-center g-5  contact-cards-wrapper">
            {/* INFO CONTATTI */}
            <div className="col-lg-6" data-aos="fade-right">
              <div className="contact-info p-4 rounded shadow-lg mb-4">
                <h4 className="fw-bold mb-3 text-primary">{t("contattiPage.informazioni")}</h4>

                <p className="mb-2">
                  📍 <strong>{t("contattiPage.indirizzoLabel")}:</strong>{" "}
                  {t("contattiPage.indirizzo")}
                </p>

                <p className="mb-2">
                  📧 <strong>{t("contattiPage.emailLabel")}:</strong>{" "}
                  <a href="mailto:info@andromedaprog.it">{t("contattiPage.email")}</a>
                </p>

                <p className="mb-3">
                  ☎️ <strong>{t("contattiPage.telefonoLabel")}:</strong>{" "}
                  {t("contattiPage.telefono")}
                </p>

                <div className="mt-4 text-center">
                  <a
                    href="mailto:info@andromedaprog.it?subject=Richiesta%20Informazioni"
                    className="contact-btn"
                  >
                    📩 {t("contattiPage.cta")}
                  </a>
                </div>

                <div className="mt-3 text-center">
                  <a
                    href="https://wa.me/393283187865"
                    target="_blank"
                    rel="noreferrer"
                    className="whatsapp-button-inline"
                  >
                    💬 WhatsApp
                  </a>
                </div>

                {/* SOCIAL */}
                <div className="social-links mt-4 text-center">
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon me-3"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>

                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon me-3"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>

                  
                </div>
              </div>
            </div>

            {/* MAPPA */}
            <div className="col-lg-6" data-aos="fade-left">
              <div className="map-container rounded shadow-lg overflow-hidden">
                <iframe
                  title="Andromeda Programmazione"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6408.123210476916!2d18.1559605!3d40.3102429!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13442a830b6f03d9%3A0xa74bfa33f63e95b1!2s73016%20San%20Cesario%20di%20Lecce%20LE!5e0!3m2!1sit!2sit!4v1731604000000"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
